import { useEffect, useState } from "react"

const useHasScroll = (ref, deps = []) => {
  const [hasScroll, setHasScroll] = useState(false)
  useEffect(() => {
    const el = ref?.current
    const update = () => setHasScroll(el?.scrollHeight > el?.clientHeight)
    update()
    const observer = new MutationObserver(update)
    observer.observe(el, {
      childList: true,
      subtree: true,
      characterData: true
    })
    window.addEventListener("resize", update)
    return () => {
      window.removeEventListener("resize", update)
      observer.disconnect()
    }
  }, deps)

  return hasScroll
}

export default useHasScroll
